module.exports = __webpack_public_path__ + "static/media/mirrorDefault.ea9492c6.png";